export const RESTRICTED_TICKET_SUBMISSION_LOG_PREFIX =
  '[Restrict Ticket Submission]';

export const ChatValidationStatusEnum = {
  /**
   * Default state of the chat validation status.
   * This state indicates that either the chat validation has not yet been triggered,
   * the user's account details are still loading,
   * or the user's account details don't meet the requirements to submit a ticket.
   */
  UNINITIALIZED: 'uninitialized',
  /**
   * Indicates that either the chat validation has been triggered and the chat is valid,
   * or the user's account details meet the requirements to submit a ticket.
   */
  VALID: 'valid',
  /**
   * Indicates that the chat validation has been triggered and the chat is invalid.
   */
  INVALID: 'invalid',
  /**
   * Indicates that the chat validation is in progress.
   */
  LOADING: 'loading',
} as const;
